export const enum EPhoneStatus {
  new = 0,
  confirmed = 1,
  codeSended = 3,
}
//статус проверки телефона (0 – новый, 1 – подтвержден, 3 – код отправлен),
